import { IRootState } from '../../types/redux/root';

export const globalLoadingSelector = (root: IRootState) => root.app.globalLoaders;
